import { useState } from 'react'
import { useCompanySafetyStock } from '../../hooks/useCompanySafetyStock'
import type { SafetyDaysConfig } from '../../lib/replenishment'

/**
 * Anti-ruptura: configura os DIAS DE SEGURANÇA por curva ABC (colchão somado ao
 * lead time no ponto de ressuprimento). Quanto maior, mais cedo o Miguel sugere
 * comprar e maior a quantidade — reduz a chance de o item zerar (status roxo).
 * A (mais crítica) costuma ter mais dias que C. 0 = sem colchão.
 *
 * Espelha o padrão do OrcamentoMensalCard (edição inline). Ao salvar, useCompanySafetyStock
 * dispara o refresh do Painel BX/Sugestão para recomputar sem reload.
 */

type Curve = keyof SafetyDaysConfig

const CURVES: { key: Curve; label: string; hint: string }[] = [
  { key: 'a', label: 'Curva A', hint: 'Itens mais críticos — maior proteção' },
  { key: 'b', label: 'Curva B', hint: 'Importância média' },
  { key: 'c', label: 'Curva C', hint: 'Cauda longa e itens sem curva' },
]

export default function SafetyStockCard() {
  const { safety, loading, saving, update } = useCompanySafetyStock()
  const [editing, setEditing] = useState<Curve | null>(null)
  const [draft, setDraft] = useState('')

  async function save(key: Curve) {
    const n = Number(draft.replace(',', '.'))
    if (Number.isFinite(n) && n >= 0) await update({ [key]: n })
    setEditing(null)
  }

  return (
    <section className="rounded-xl border border-line bg-surface px-4 py-3">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <h3 className="text-xs font-semibold uppercase tracking-wide text-ink-faint">
          Estoque de segurança — dias por curva ABC
        </h3>
        <p className="text-[11px] text-ink-faint">
          Dias de cobertura somados ao lead time no ponto de ressuprimento. Evita ruptura (roxo).
        </p>
      </div>

      <div className="mt-3 grid grid-cols-3 gap-3">
        {CURVES.map(({ key, label, hint }) => (
          <label key={key} className="flex flex-col gap-0.5">
            <span className="text-[10px] uppercase tracking-wide text-ink-faint" title={hint}>{label}</span>
            {editing === key ? (
              <input
                autoFocus
                type="number"
                min={0}
                defaultValue={String(safety[key])}
                onChange={e => setDraft(e.target.value)}
                onBlur={() => save(key)}
                onKeyDown={e => { if (e.key === 'Enter') save(key) }}
                disabled={saving}
                className="w-full bg-paper border border-brand-400 rounded px-2 py-1 text-right text-ink text-sm focus:outline-none"
              />
            ) : (
              <button
                onClick={() => { setDraft(String(safety[key])); setEditing(key) }}
                disabled={loading}
                className="w-full text-right tabular-nums px-2 py-1 rounded border border-line bg-paper hover:border-brand-400 text-ink text-sm transition-colors disabled:opacity-50"
                title="Clique para editar (dias)"
              >
                {safety[key]} {safety[key] === 1 ? 'dia' : 'dias'}
              </button>
            )}
          </label>
        ))}
      </div>
    </section>
  )
}
